import type { OpportunityPriority } from '@/services/bff/types/opportunity';

export const OPPORTUNITY_PRIORITY_OPTIONS: {
  label: string;
  value: OpportunityPriority;
}[] = [
  { label: '高', value: 'high' },
  { label: '中高', value: 'mid_high' },
  { label: '中', value: 'medium' },
  { label: '中低', value: 'mid_low' },
  { label: '低', value: 'low' },
];
export const OPPORTUNITY_PRIORITY_META: Record<
  OpportunityPriority,
  { label: string; color: string }
> = {
  high: { label: '高', color: 'red' },
  mid_high: { label: '中高', color: 'orange' },
  medium: { label: '中', color: 'gold' },
  mid_low: { label: '中低', color: 'blue' },
  low: { label: '低', color: 'default' },
};
export const opportunityPriorityLabel = (value?: OpportunityPriority) =>
  OPPORTUNITY_PRIORITY_META[value || 'medium']?.label || '中';

/** Task Center retains its own three-level priority vocabulary. */
export const opportunityTaskPriority = (
  value: OpportunityPriority,
): 'high' | 'medium' | 'low' =>
  value === 'mid_high' ? 'high' : value === 'mid_low' ? 'low' : value;
